import { useEffect, useState } from 'react'
import globalStore from '@src/store/common/global'

export function useLoading() {
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		const unSubscribe = globalStore.subscribe((state) => setLoading(state.loading))
		return () => {
			unSubscribe()
		}
	}, [])

	return {
		loading
	}
}
